import axios from 'axios';
import { API_URL } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchLiveTrackingItems = async () => {
  const response = await axios.get(`${API_URL}/live-tracking`, { headers: authHeaders() });
  return Array.isArray(response.data) ? response.data : [];
};

export const upsertLiveTrackingItem = async (payload) => {
  const response = await axios.post(`${API_URL}/live-tracking`, payload, { headers: authHeaders() });
  return response.data;
};

export const updateLiveTrackingItem = async (id, payload) => {
  const response = await axios.put(`${API_URL}/live-tracking/${id}`, payload, { headers: authHeaders() });
  return response.data;
};

export const deleteLiveTrackingItem = async (id) => {
  await axios.delete(`${API_URL}/live-tracking/${id}`, { headers: authHeaders() });
};

export const markLiveTrackingOpened = async (id, seenSignature) => {
  const response = await axios.put(
    `${API_URL}/live-tracking/${id}/opened`,
    { seenSignature },
    { headers: authHeaders() },
  );
  return response.data;
};

export const reorderLiveTrackingItems = async (ids, lanes = {}) => {
  const response = await axios.put(
    `${API_URL}/live-tracking/reorder`,
    { ids, lanes },
    { headers: authHeaders() },
  );
  return Array.isArray(response.data) ? response.data : [];
};
